import axios from "@/axios.js";
import constants from "@/constants.js";

export default {
  async calculatePrice({ commit }, payload) {
    try {
      const res = await axios.post(
        `${constants.paymentsServiceUrl}/plan-subscriptions/calculate-price`,
        payload
      );
      commit("SET_PRICE_BREAKDOWN", res.data.data);
      return res.data;
    } catch (error) {
      console.error("Failed to calculate price:", error);
      throw error;
    }
  },

  async createSubscription({ commit }, payload) {
    try {
      const res = await axios.post(
        `${constants.paymentsServiceUrl}/plan-subscriptions/create`,
        payload
      );
      // axios interceptor returns response on error (doesn't throw)
      // so we need to check status and data shape
      const data = res && res.data;
      if (!data || !data.success || !data.data) {
        const errMsg = (data && data.error) || 'Subscription creation failed';
        throw new Error(errMsg);
      }
      commit("SET_CURRENT_SUBSCRIPTION", data.data);
      commit("SET_CLIENT_SECRET", data.data.clientSecret);
      return data;
    } catch (error) {
      console.error("Failed to create plan subscription:", error);
      throw error;
    }
  },

  async confirmPayment({ commit }, payload) {
    try {
      commit("SET_PAYMENT_STATUS", "processing");
      const res = await axios.post(
        `${constants.paymentsServiceUrl}/plan-subscriptions/confirm`,
        payload
      );
      commit("SET_PAYMENT_STATUS", "succeeded");
      commit("SET_CURRENT_SUBSCRIPTION", res.data.data);
      return res.data;
    } catch (error) {
      commit("SET_PAYMENT_STATUS", "failed");
      console.error("Failed to confirm payment:", error);
      throw error;
    }
  },

  async fetchSubscription({ commit }, subscriptionId) {
    try {
      const res = await axios.get(
        `${constants.paymentsServiceUrl}/plan-subscriptions/${subscriptionId}`
      );
      commit("SET_CURRENT_SUBSCRIPTION", res.data.data);
      return res.data;
    } catch (error) {
      console.error("Failed to fetch subscription:", error);
      throw error;
    }
  },

  async resumePayment({ commit }, boardId) {
    try {
      const res = await axios.post(
        `${constants.paymentsServiceUrl}/plan-subscriptions/resume/${boardId}`
      );
      const data = res && res.data;
      if (!data || !data.success || !data.data) {
        throw new Error((data && data.error) || 'Resume payment failed');
      }
      commit("SET_CURRENT_SUBSCRIPTION", data.data);
      if (data.data.clientSecret) {
        commit("SET_CLIENT_SECRET", data.data.clientSecret);
      }
      return data;
    } catch (error) {
      console.error("Failed to resume payment:", error);
      throw error;
    }
  },

  resetPaymentState({ commit }) {
    commit("RESET_PAYMENT_STATE");
  },
};
